import { useEffect, useRef } from "react";
import billioncircle1 from "../../../assets/images/billioncircle1.png";
import billioncircle2 from "../../../assets/images/billioncircle2.png";
import rightarrow from "../../../assets/images/rightarrow.png";
import "./Billion.scss";
import * as $ from "jquery";

const SCROLL_CONFIG = {
  mobile: { min: 0.6, max: 0.9 }, // Scroll range as percentage of document height
  desktop: { min: 0.5, max: 0.95 },
};

const Billion = () => {
  const annualBudgetElement = useRef();
  const arrowElement = useRef();

  /* useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      animateBillions(scrollPosition);
    };

    const animateBillions = (scrollPosition) => {
      const target1 = annualBudgetElement.current;
      const target2 = arrowElement.current;

      const documentHeight = document.body.scrollHeight;
      const config =
        window.innerWidth < 577 ? SCROLL_CONFIG.mobile : SCROLL_CONFIG.desktop;

      const minThreshold = config.min * documentHeight;
      const maxThreshold = config.max * documentHeight;

      const isInRange =
        scrollPosition >= minThreshold && scrollPosition <= maxThreshold;

      if (target1 && target2) {
        target1.style.transform = isInRange ? "scale(1)" : "scale(0.2)";
        target2.style.marginLeft = isInRange
          ? window.innerWidth < 577
            ? "initial"
            : "50px"
          : "-90px";
        target2.style.zIndex = "-1"; // This style remains constant
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  */

  return (
    <section>
      <div className="container">
        <div className="title">
          <span>~$33-39bn</span> at stake due to the impacts of{" "}
          <span>Sea Level Rise, Extreme Rainfall &amp; Extreme Heat</span> by
          2050
        </div>
        <div className="billions-section">
          <div className="subtitle">
            The cost of inaction greatly exceeds the State Budget, but can be
            averted for a fraction of the cost through investment in critical
            projects across the state.
          </div>
          <div className="custom-row billions">
            {/* <div className="custom-row"> */}
            <div>
              <div className="bilioncircle-top">
                <img
                  src={billioncircle1}
                  alt="billioncircle1"
                  className="billioncircle"
                />
              </div>
              <div>Cost Of Climate Inaction</div>
            </div>
            <img
              src={rightarrow}
              alt="rightarrow"
              className="rightarrow"
              ref={arrowElement}
            />
            <div>
              <div className="bilioncircle-top">
                <img
                  src={billioncircle2}
                  alt="billioncircle2"
                  className="billioncircle"
                  ref={annualBudgetElement}
                />
              </div>
              <div>
                Lagos State 2024 Annual Budget* <br />
                <div className="note">* Conversion @ $1 = ₦1600</div>
              </div>
            </div>
          </div>
        </div>
        <div className="footnote">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23.646"
            height="21.278"
            viewBox="0 0 23.646 21.278"
          >
            <g
              id="Group_2684"
              data-name="Group 2684"
              transform="translate(-1.177 -2.262)"
            >
              <path
                id="Path_88261"
                data-name="Path 88261"
                d="M21.843,22.791H4.156A2.2,2.2,0,0,1,2.25,19.5l8.844-15.38a2.2,2.2,0,0,1,3.813,0L23.75,19.5A2.2,2.2,0,0,1,21.843,22.791Z"
                transform="translate(0 0)"
                fill="none"
                stroke="#d2473d"
                stroke-linecap="round"
                stroke-width="1.5"
              />
              <path
                id="Path_88262"
                data-name="Path 88262"
                d="M12,9v4.4"
                transform="translate(1 0.596)"
                fill="none"
                stroke="#d2473d"
                stroke-linecap="round"
                stroke-width="1.5"
              />
              <path
                id="Path_88263"
                data-name="Path 88263"
                d="M12,17.011,12.011,17"
                transform="translate(1 1.392)"
                fill="none"
                stroke="#d2473d"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </g>
          </svg>
          <div>
            The cost of inaction is{" "}
            <b>$30-39Bn, which is 27X the state budget</b>, but it can be{" "}
            <b>averted with $9Bn in investment.</b>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Billion;
